import { Component, Input, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  LANGUAGE_CODES_DEEPGRAM,
  LLM_MODELS_DEEPGRAM,
  LLM_MODELS_TELEGO,
  TRANSCRIPTION_PROVIDERS,
  TranscriptionProvider,
} from './transcription-settings.const';
import { EVENT_FLOW_FIELD_LABELS } from '../../node-parameters/constants/event-flow-field-labels.const';
import { MatSimpleSelectComponent } from '../../../../editors/mat-simple-select/mat-simple-select.component';
import { MatTextareaInputComponent } from '../../../../editors/mat-textarea-input/mat-textarea-input.component';
import { NgFor } from '@angular/common';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { FlexModule } from '@angular/flex-layout';
import { MatTooltip } from '@angular/material/tooltip';
import { MatMultiselectComponent } from '../../../../editors/mat-multiselect-input/mat-multiselect.component';
import { MatSlideToggleInputComponent } from '../../../../editors/mat-slide-toggle-input/mat-slide-toggle-input.component';

@Component({
  selector: 'events-fow-transcription-settings',
  templateUrl: './transcription-settings.component.html',
  styleUrls: ['./transcription-settings.component.scss'],
  standalone: true,
  imports: [
    MatSimpleSelectComponent,
    FormsModule,
    ReactiveFormsModule,
    MatTextareaInputComponent,
    NgFor,
    MatIconButton,
    MatIcon,
    MatButton,
    MatMultiselectComponent,
    FlexModule,
    MatTooltip,
    MatSlideToggleInputComponent,
  ],
})
export class TranscriptionSettingsComponent {
  @Input({ required: true })
  actionItemFormGroup!: FormGroup;

  public readonly transcriptionProviders = TRANSCRIPTION_PROVIDERS;
  public readonly deepgramLanguage = LANGUAGE_CODES_DEEPGRAM;
  public readonly fieldLabels = EVENT_FLOW_FIELD_LABELS;

  onProviderChange(): void {
    this.modelFormControl.reset();
  }

  get availableModels() {
    return this.providerFormControl?.value === TranscriptionProvider.Telego ? LLM_MODELS_TELEGO : LLM_MODELS_DEEPGRAM;
  }

  get providerFormControl(): FormControl {
    return this.actionItemFormGroup.get('provider') as FormControl;
  }
  constructor(private fb: FormBuilder) {}

  get languageFormControl(): FormControl {
    return this.actionItemFormGroup.get('language') as FormControl;
  }

  get modelFormControl(): FormControl {
    return this.actionItemFormGroup.get('model') as FormControl;
  }

  get systemPromptFormControl(): FormControl {
    return this.actionItemFormGroup.get('summarySystemPrompt') as FormControl;
  }

  get userPromptFormControl(): FormControl {
    return this.actionItemFormGroup.get('summaryUserPrompt') as FormControl;
  }

  get skipStorageFormControl(): FormControl {
    return this.actionItemFormGroup.get('skipStorage') as FormControl;
  }

  get extensionOverridesArray(): FormArray {
    return this.actionItemFormGroup.get('extensionOverrides') as FormArray;
  }

  addExtensionOverride(): void {
    this.extensionOverridesArray.push(
      this.fb.group({
        extensions: this.fb.control([], [Validators.required, Validators.minLength(1)]),
        language: ['', Validators.required],
      }),
    );
  }

  removeExtensionOverride(index: number): void {
    this.extensionOverridesArray.removeAt(index);
  }
}
